import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store"; // Make sure this is the correct path to your Vuex store setupInterceptors from './services/setupInterceptors';

import { FontAwesomeIcon } from "./plugins/font-awesome";

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import "./assets/reset.css";

createApp(App)
  .use(router)
  // Integrate Vuex directly into Vue 3
  .use(store)
  // Remove this line since Vuex is integrated directly
  // .use(Vuex)
  .use(VueSweetalert2)
  // .use(BootstrapVue)
  // .use(IconsPlugin)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
